<div class="row top-content-border bottom-content-border" [ngStyle]="{'height.px': workspaceHeight}"
  style="margin-left:30px;margin-right:30px ;">
  <form class="form-horizontal ed-form-horizontal;" autocomplete="off">
    <div class="black-workspace col-md-12" style="padding: 10px;">
      <h3>{{gridTitle}}</h3>
      <hr />
      <div class="panel" style="border:none; height: 150px; margin-top: 10%;">
        <div class="col-md-4 col-md-offset-4">
          <button type="button" class="btn cs-btn-amber" style="height:40px;" 
            [disabled]="drivetimeServiceButtonDisabled" (click)="restartService('Drivetime')">
            Restart Drivetimes Service
          </button>
        </div>
      </div>
      <div class="panel" style="border:none; height: 150px; margin-top: 10%;">
        <div class="col-md-4 col-md-offset-4">
          <button type="button" class="btn cs-btn-amber" style="height:40px;" 
            [disabled]="optimiserServiceButtonDisabled" (click)="restartService('Optimiser')">
            Restart Optimiser Service
          </button>
        </div>
      </div>
    </div>
  </form>
</div>


<div class="row">
   &nbsp;
</div>
